export default "__VITE_ASSET__BFSiR_5e__"